import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { scanDmcPageQueryOptions, unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import type { ScanDmcPageInitialData } from "~/app/api/pageData/scanDmcPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { ScanDMC } from "~/pages/ScanDmcPage/ScanDmcPage";
import { rootRoute } from "~/app/router/rootRoute";

function ScanDmcRoute() {
  const result = useLoaderData({
    from: "/scandmc",
  }) as PageInitialData<ScanDmcPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <ScanDMC oneCodeImplUrl={result.data.oneCodeImplUrl} />
    </StorefrontShellFrame>
  );
}

export async function loadScanDmcPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(scanDmcPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const scanDmcRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/scandmc",
  loader: async ({ context }) => loadScanDmcPageData(context),
  component: ScanDmcRoute,
});
